import React, { useEffect, useState } from "react";
import {
  ThinDropdownWithSearch,
  ThinTextField,
} from "../common/GeneralComponent";

import { fetchData } from "../../utils/functions";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const Housting = ({ houseHoldHousing, DqaApproved, DqaRejected }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const household_information_id = houseHoldHousing?.household_information_id;
  const household_housing_id = houseHoldHousing?.household_housing_id;

  const [isDqaApproved, setIsDqaApproved] = useState(DqaApproved || false);
  const [isDqaRejected, setIsDqaRejected] = useState(DqaRejected || false);
  // const [isDqaRejected, setIsDqaRejected] = useState(false);
  const [householdInfoData, setHouseholdInfoData] = useState(null);

  // errors
  const [errors, setErrors] = useState({});

  const [saveAttempted, setSaveAttempted] = useState(false);
  useEffect(() => {
    if (saveAttempted) validate();
  });

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";
    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }
    const baseUrl = process.env.REACT_APP_BASE_URL;
    return `${baseUrl}/uploads/house/${imagePath}`;
  };

  const getDisplayName = (imagePath) => {
    if (!imagePath) return "";
    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath.split("/").pop();
    }
    return imagePath;
  };

  useEffect(() => {
    setIsDqaApproved(DqaApproved || false);
    setIsDqaRejected(DqaRejected || false);
  }, [DqaApproved, DqaRejected]);

  useEffect(() => {
    if (houseHoldHousing) {
      setSelectedTenure(houseHoldHousing?.tenure_status || "");
      setSelectedMatrial(houseHoldHousing?.material_used_roof || "");
      setSelectedWalls(houseHoldHousing?.material_used_for_walls || "");
      setRoofOther(houseHoldHousing?.material_used_roof_other_specify || "");
      setWallOther(
        houseHoldHousing?.material_used_for_walls_other_specify || ""
      );

      setSelectedFloor(houseHoldHousing?.type_of_floor || "");
      setSelectedRoom(houseHoldHousing?.number_of_rooms || "");
      setSelectedWater(houseHoldHousing?.source_of_water || "");
      const waterShortageValue =
        houseHoldHousing?.last_month_qty_of_drinking_water;
      setWaterShortage(
        waterShortageValue !== null && waterShortageValue !== undefined
          ? Number(waterShortageValue)
          : undefined
      );
      setFetchingWaterTimeTaken(
        houseHoldHousing?.fetching_water_time_taken || ""
      );
      setCostPerMonth(houseHoldHousing?.fetching_water_cost_per_month || "");
      setWashHand(houseHoldHousing?.handwash_usually_wash_hands || "");
      setGarbage(houseHoldHousing?.garbage_how_dispose || "");
      setWater(houseHoldHousing?.water_available_for_handwash ?? undefined);
      setSoap(houseHoldHousing?.soap_available_for_handwash ?? undefined);
      setToilet(houseHoldHousing?.type_of_toilet || "");
      setFuel(houseHoldHousing?.fuel_used_for_lighting || "");
      setFuelOthers(houseHoldHousing?.fuel_used_for_lighting_others || "");
      setCooking(houseHoldHousing?.fuel_used_for_cooking || "");
      setCookingOthers(houseHoldHousing?.fuel_used_for_cooking_others || "");
      setSeparateKitchen(
        houseHoldHousing?.cooking_separate_kitchen ?? undefined
      );
      setHasChimney(houseHoldHousing?.cooking_has_chimney ?? undefined);
      setLightingCostPerMonth(houseHoldHousing?.lighting_cost_per_month || "");
      setCookingCostPerMonth(houseHoldHousing?.cooking_cost_per_month || "");
      setHeightOfHouse(houseHoldHousing?.height_of_house || "");
      sethouseholdhousingid(houseHoldHousing?.household_housing_id || "");
      setHomeImage(houseHoldHousing?.home_image || "");
    }
  }, [houseHoldHousing]);

  const Tenure = [
    { value: "Own", label: "Own" },
    { value: "Rent", label: "Rent" },
    { value: "Free", label: "Free" },
    { value: "Landlord Owned", label: "Landlord Owned" },
    { value: "Government", label: "Government" },
    { value: "Gifted / NGO scheme", label: "Gifted / NGO scheme" },
  ];
  const Material = [
    { value: "RCC / RBC", label: "RCC / RBC" },
    { value: "Wood / Bamboo", label: "Wood / Bamboo" },
    { value: "Sheet / Iron / Cement", label: "Sheet / Iron / Cement" },
    { value: "T-Iron / Girder", label: "T-Iron / Girder" },
    { value: "Others", label: "Others" },
  ];
  const Walls = [
    { value: "Burnt Bricks / Blocks", label: "Burnt Bricks / Blocks" },
    { value: "Mud Bricks / Mud", label: "Mud Bricks / Mud" },
    { value: "Wood", label: "Wood" },
    { value: "Others", label: "Others" },
  ];
  const Floor = [
    { value: "Katcha", label: "Katcha" },
    { value: "Pukka", label: "Pukka" },
  ];
  const Room = [
    { value: "One", label: "One" },
    { value: "Two", label: "Two" },
    { value: "Three", label: "Three" },
    { value: "Four", label: "Four" },
    { value: "Five and above", label: "Five and above" },
  ];
  const Toilet = [
    { value: "Flush/pour-flush", label: "Flush/pour-flush" },
    { value: "Dry pit latrine", label: "Dry pit latrine" },
    { value: "Bucket", label: "Bucket" },
    { value: "Hanging toilet", label: "Hanging toilet" },
    { value: "No facilities/bush/field", label: "No facilities/bush/field" },
    { value: "Others", label: "Others" },
    { value: "Hanging toilet/hanging latrine", label: "Hanging toilet/hanging latrine" },
  ];
  const Fuel = [
    { value: "Electricity", label: "Electricity" },
    { value: "Gas/oil", label: "Gas/oil" },
    { value: "Wood/candle", label: "Wood/candle" },
    { value: "Solar", label: "Solar" },
    { value: "Wind Turbine", label: "Wind Turbine" },
    { value: "Oil", label: "Oil" },
    { value: "Others", label: "Others" },
    { value: "No any", label: "No any" },
    { value: "Torch", label: "Torch" },
    { value: "No Light", label: "No Light" },
  ];
  const Cooking = [
    { value: "Gas", label: "Gas" },
    { value: "Cow Dung", label: "Cow Dung" },
    { value: "Wood / Sticks", label: "Wood / Sticks" },
    { value: "Oil", label: "Oil" },
    { value: "Others", label: "Others" },
  ];
  const Water = [
    { value: "Tap Water", label: "Tap Water" },
    { value: "Hand Pump/Motor pump", label: "Hand Pump/Motor pump" },
    { value: "Protected well", label: "Protected well" },
    { value: "Unprotected well", label: "Unprotected well" },
    { value: "Rainwater collection", label: "Rainwater collection" },
    { value: "Water truck", label: "Water truck" },
    { value: "Bottled water", label: "Bottled water" },
    {
      value: "Surface water (canals, rivers, ponds)",
      label: "Surface water (canals, rivers, ponds)",
    },
  ];
  const WashHands = [
    {
      value: "Fixed facility (sink, tap)",
      label: "Fixed facility (sink, tap)",
    },
    {
      value: "Mobile object (bucket/jug/kettle)",
      label: "Mobile object (bucket/jug/kettle)",
    },
    {
      value: "No handwashing place in dwelling/yard/plot",
      label: "No handwashing place in dwelling/yard/plot",
    },
    { value: "No permission to see", label: "No permission to see" },
  ];
  const garbageDispose = [
    {
      value: "Collected by formal service provider",
      label: "Collected by formal service provider",
    },
    {
      value: "Collected by informal service provider",
      label: "Collected by informal service provider",
    },
    {
      value: "Disposed of in designated waste disposal area",
      label: "Disposed of in designated waste disposal area",
    },
    {
      value: "Disposed of within household or yard or plot",
      label: "Disposed of within household or yard or plot",
    },
    { value: "Buried or burnt", label: "Buried or burnt" },
    { value: "Disposed elsewhere", label: "Disposed elsewhere" },
    { value: "Don't know", label: "Don't know" },
  ];

  const [householdListingid, sethouseholdhousingid] = useState("");
  const [selectedTenure, setSelectedTenure] = useState("");
  const [selectedMatrial, setSelectedMatrial] = useState("");
  const [selectedWalls, setSelectedWalls] = useState("");
  const [roofOther, setRoofOther] = useState("");
  const [wallOther, setWallOther] = useState("");
  const [selectedFloor, setSelectedFloor] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedWater, setSelectedWater] = useState("");
  const [waterShortage, setWaterShortage] = useState(undefined);
  const [fetchingWaterTimeTaken, setFetchingWaterTimeTaken] = useState("");
  const [costPerMonth, setCostPerMonth] = useState("");
  const [washHand, setWashHand] = useState("");
  const [garbage, setGarbage] = useState("");
  const [water, setWater] = useState(undefined);
  const [soap, setSoap] = useState(undefined);
  const [toilet, setToilet] = useState("");
  const [fuel, setFuel] = useState("");
  // const [otherFuel, setOtherFuel] = useState("");
  const [cooking, setCooking] = useState("");
  // const [otherCooking, setOtherCooking] = useState("");
  const [separateKitchen, setSeparateKitchen] = useState(undefined);
  const [hasChimney, setHasChimney] = useState(undefined);
  const [lightingCostPerMonth, setLightingCostPerMonth] = useState("");
  const [cookingCostPerMonth, setCookingCostPerMonth] = useState("");
  const [heightOfHouse, setHeightOfHouse] = useState("");
  const [homeImage, setHomeImage] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [fuelOthers, setFuelOthers] = useState("");
  const [cookingOthers, setCookingOthers] = useState("");

  const handleTenureceChange = (value) => setSelectedTenure(value);
  const handleMaterialChange = (value) => setSelectedMatrial(value);
  const handleWallsChange = (value) => setSelectedWalls(value);
  const handleFloorChange = (value) => setSelectedFloor(value);
  const handleRoomChange = (value) => setSelectedRoom(value);
  const handleWaterChange = (value) => setSelectedWater(value);
  const handleWaterShortageChange = (value) => setWaterShortage(value);
  const handleWashChange = (value) => setWashHand(value);
  const handleGarbageChange = (value) => setGarbage(value);
  const handleWaterAvailableChange = (value) => setWater(value);
  const handleWashHandChange = (value) => setSoap(value);
  const handleToiletChange = (value) => setToilet(value);
  const handleFuelChange = (value) => {
    setFuel(value);
    if (value !== "Others") setFuelOthers("");
  };
  const handleCookingChange = (value) => {
    setCooking(value);
    if (value !== "Others") setCookingOthers("");
  };
  const handleSeparateKitchenChange = (value) => setSeparateKitchen(value);
  const handleHasChimneyChange = (value) => setHasChimney(value);

  const handleImageClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (homeImage) setShowImageModal(true);
  };
  const closeImageModal = (e) => {
    e?.stopPropagation();
    setShowImageModal(false);
  };

  const isDataValid =
    houseHoldHousing &&
    (selectedTenure ||
      selectedMatrial ||
      selectedWalls ||
      selectedFloor ||
      selectedRoom ||
      selectedWater ||
      washHand ||
      garbage ||
      toilet ||
      fuel ||
      cooking ||
      fetchingWaterTimeTaken ||
      costPerMonth);

  // ---------- VALIDATION ----------
  const validate = () => {
    const e = {};
    const req = (v) => v !== undefined && v !== null && String(v).trim() !== "";

    if (!req(selectedTenure)) e.selectedTenure = " Tenure Status is Required.";
    if (!req(selectedMatrial))
      e.selectedMatrial = "Material used for Roof is Required.";
    if (!req(selectedWalls))
      e.selectedWalls = "Material used for Walls is Required.";
    if (selectedMatrial === "Others" && !req(roofOther))
      e.roofOther = "Other roof material is required.";

    if (selectedWalls === "Others" && !req(wallOther))
      e.wallOther = "Other wall material is required.";
    if (!req(selectedFloor)) e.selectedFloor = "Type of Floor is Required.";
    if (!req(selectedRoom)) e.selectedRoom = "Number of Rooms is Required.";
    if (!req(selectedWater)) e.selectedWater = "Source of Water  is Required.";
    if (fetchingWaterTimeTaken < 1) {
      e.fetchingWaterTimeTaken = "Minimum value is 1 minute.";
    } else if (fetchingWaterTimeTaken > 1600) {
      e.fetchingWaterTimeTaken = "Maximum value is 1600 minutes.";
    }
    if (!req(costPerMonth < 0)) e.costPerMonth = "Minimum value should be 0.";
    if (!req(washHand)) e.washHand = "Wash hand is Required.";
    if (!req(garbage)) e.garbage = "Garbage is Required.";
    if (!req(toilet)) e.toilet = "Type of Toilet is Required.";
    if (!req(lightingCostPerMonth))
      e.lightingCostPerMonth = "Lighting cost is Required.";
    if (!req(cookingCostPerMonth))
      e.cookingCostPerMonth = "Cooking cost is Required.";

    if (!req(fuel)) e.fuel = "Fuel used for Lighting is Required.";
    if (fuel === "Others" && !req(fuelOthers))
      e.fuelOthers = "other lighting fuel is required.";

    if (!req(cooking)) e.cooking = "Fuel used for Cooking is Required.";
    if (cooking === "Others" && !req(cookingOthers))
      e.cookingOthers = " other cooking fuel is required.";

    if (waterShortage !== 0 && waterShortage !== 1)
      e.waterShortage = "Please select Yes or No.";
    if (water !== 0 && water !== 1 && water !== true && water !== false)
      e.water = "Please select Yes or No.";
    if (soap !== 0 && soap !== 1 && soap !== true && soap !== false)
      e.soap = "Please select Yes or No.";

    if (String(costPerMonth).trim() !== "") {
      const n = Number(costPerMonth);
      if (Number.isNaN(n) || n < 0)
        e.costPerMonth = "Enter a non-negative number.";
    }

    if (String(lightingCostPerMonth).trim() !== "") {
      const n = Number(lightingCostPerMonth);
      if (Number.isNaN(n) || n < 0)
        e.lightingCostPerMonth = "Enter a non-negative number.";
    }

    if (String(cookingCostPerMonth).trim() !== "") {
      const n = Number(cookingCostPerMonth);
      if (Number.isNaN(n) || n < 0)
        e.cookingCostPerMonth = "Enter a non-negative number.";
    }

    if (String(heightOfHouse).trim() !== "") {
      const n = Number(heightOfHouse);
      if (Number.isNaN(n) || n < 0)
        e.heightOfHouse = "Enter a non-negative number.";
    }

    setErrors((prev) =>
      JSON.stringify(prev) === JSON.stringify(e) ? prev : e
    );
    return Object.keys(e).length === 0;
  };

  const handleUpdateHousing = async () => {
    setSaveAttempted(true);
    if (!validate()) {
      return;
    }

    try {
      const payload = {
        household_information_id,
        household_housing_id,
        tenure_status: selectedTenure,
        material_used_roof: selectedMatrial,
        material_used_for_walls: selectedWalls,
        material_used_roof_other_specify:
          selectedMatrial === "Others" ? roofOther : null,
        material_used_for_walls_other_specify:
          selectedWalls === "Others" ? wallOther : null,
        type_of_floor: selectedFloor,
        number_of_rooms: selectedRoom,
        source_of_water: selectedWater,
        last_month_qty_of_drinking_water: Number(waterShortage),
        fetching_water_time_taken: fetchingWaterTimeTaken,
        fetching_water_cost_per_month:
          String(costPerMonth).trim() === "" ? null : Number(costPerMonth),
        handwash_usually_wash_hands: washHand,
        garbage_how_dispose: garbage,
        water_available_for_handwash: Number(water),
        soap_available_for_handwash: Number(soap),
        type_of_toilet: toilet,
        fuel_used_for_lighting: fuel,
        fuel_used_for_lighting_other_specify:
          fuel === "Others" ? fuelOthers : null,
        fuel_used_for_cooking: cooking,
        fuel_used_for_cooking_other_specify:
          cooking === "Others" ? cookingOthers : null,
        cooking_separate_kitchen:
          separateKitchen !== undefined ? Number(separateKitchen) : null,
        cooking_has_chimney:
          hasChimney !== undefined ? Number(hasChimney) : null,
        lighting_cost_per_month:
          String(lightingCostPerMonth).trim() === ""
            ? null
            : Number(lightingCostPerMonth),
        cooking_cost_per_month:
          String(cookingCostPerMonth).trim() === ""
            ? null
            : Number(cookingCostPerMonth),
        height_of_house:
          String(heightOfHouse).trim() === "" ? null : Number(heightOfHouse),
      };

      const res = await fetchData(
        `household-housing-update/${household_housing_id}`,
        "PUT",
        payload
      );
      if (res.success) {
        toast.success("Housing data updated successfully");
      } else {
        toast.error(res.message || "Failed to update housing data");
      }
    } catch (error) {
      toast.error("An error occurred while updating housing data");
      console.error("Update error:", error);
    }
  };

  // helper to render error text
  const Err = (name) =>
    errors?.[name] ? (
      <p className="text-[0.9rem] text-red-600 mt-2">{errors[name]}</p>
    ) : null;

  return (
    <div className="bg-white rounded">
      {/* <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-4">
          {isDqaApproved && (
            <>
              <h2 className="text-teal-700 text-xl font-semibold">
                Household Information
              </h2>
              <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
                Approved from DQA
              </span>
            </>
          )}
        </div>
      </div> */}

      <div className="flex justify-between items-center mb-3">
        {isDqaApproved && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              Household Housing
            </h2>
            <span className="bg-blue-100 text-blue-800 px-1 py-1 rounded-full text-sm font-semibold">
              Approved from DQA
            </span>
          </>
        )}
        {isDqaRejected && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              Household Housing
            </h2>

            <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-semibold">
              Rejected from DQA
            </span>
          </>
        )}
      </div>

      {houseHoldHousing ? (
        <form className="w-full">
          {/* Survey House Image */}
          {homeImage && (
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Survey House Image
              </label>
              <div className="border border-gray-300 rounded-md p-4 bg-gray-50">
                <button
                  type="button"
                  className="flex items-center gap-2 cursor-pointer hover:bg-blue-50 p-3 rounded-md transition-all duration-200 border border-transparent hover:border-blue-200 w-full text-left"
                  onClick={handleImageClick}
                  title="Click to view image"
                >
                  <i className="fa fa-image text-blue-500 text-lg"></i>
                  <span className="text-sm text-blue-600 hover:text-blue-800 font-medium">
                    Survey House Image
                  </span>
                  <i className="fa fa-eye text-sm text-blue-400 ml-auto"></i>
                </button>
              </div>
            </div>
          )}

          {/* Show placeholder if no image */}
          {!homeImage && (
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Home Image
              </label>
              <div className="border border-gray-300 rounded-md p-4 bg-gray-50">
                <div className="flex items-center gap-2 p-3 text-gray-500">
                  <i className="fa fa-image text-gray-400 text-lg"></i>
                  <span className="text-sm">No home image available</span>
                </div>
              </div>
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* 1. Tenure Status */}
            <div>
              <ThinDropdownWithSearch
                label="Tenure Status"
                options={Tenure}
                value={selectedTenure}
                onChange={handleTenureceChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("selectedTenure")}
            </div>

            {/* 2. Material used for Roof */}
            <div>
              <ThinDropdownWithSearch
                label="Material used for Roof"
                options={Material}
                value={selectedMatrial}
                onChange={handleMaterialChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("selectedMatrial")}
              {selectedMatrial === "Others" && (
                <>
                  <ThinTextField
                    label="Specify other roof material"
                    value={roofOther}
                    isRequired={true}
                    onChange={(e) => setRoofOther(e.target.value)}
                    disabled={isDqaApproved || isDqaRejected}
                    className="mt-2"
                  />
                  {Err("roofOther")}
                </>
              )}
            </div>

            {/* 3. Material used for Walls */}
            <div>
              <ThinDropdownWithSearch
                label="Material used for Walls"
                options={Walls}
                value={selectedWalls}
                onChange={handleWallsChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("selectedWalls")}
              {selectedWalls === "Others" && (
                <>
                  <ThinTextField
                    label="Specify other wall material"
                    value={wallOther}
                    isRequired={true}
                    onChange={(e) => setWallOther(e.target.value)}
                    disabled={isDqaApproved || isDqaRejected}
                    className="mt-2"
                  />
                  {Err("wallOther")}
                </>
              )}
            </div>

            {/* 4. Type of Floor */}
            <div>
              <ThinDropdownWithSearch
                label="Type of Floor"
                options={Floor}
                value={selectedFloor}
                onChange={handleFloorChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("selectedFloor")}
            </div>

            {/* 5. Number of Rooms */}
            <div>
              <ThinDropdownWithSearch
                label="Number of Rooms"
                options={Room}
                value={selectedRoom}
                onChange={handleRoomChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("selectedRoom")}
            </div>

            {/* 6. Source of Water */}
            <div>
              <ThinDropdownWithSearch
                label="Source of Water"
                options={Water}
                value={selectedWater}
                onChange={handleWaterChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("selectedWater")}
            </div>

            {/* 7. In the last month, has there been any time when... */}
            <div className="md:col-span-3">
              <p className="mb-2 text-sm font-medium text-gray-700">
                In the last month, has there been any time when there were no
                sufficient quantities of drinking water?
              </p>
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="water-shortage"
                    value={1}
                    checked={Number(waterShortage) === 1}
                    onChange={() => handleWaterShortageChange(1)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">Yes</span>
                </label>
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="water-shortage"
                    value={0}
                    checked={Number(waterShortage) === 0}
                    onChange={() => handleWaterShortageChange(0)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">No</span>
                </label>
              </div>
              {Err("waterShortage")}
            </div>

            {/* 8. Time taken to fetch water */}
            <div>
              <ThinTextField
                value={fetchingWaterTimeTaken}
                label="Time taken to fetch water (minutes)"
                isRequired={false}
                onChange={(e) =>
                  setFetchingWaterTimeTaken(e.target.value.slice(0, 4))
                }
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("fetchingWaterTimeTaken")}
            </div>

            {/* 9. Cost water */}
            <div>
              <ThinTextField
                value={costPerMonth}
                label="Cost of water (per month)"
                isRequired={false}
                onChange={(e) => setCostPerMonth(e.target.value.slice(0, 5))}
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("costPerMonth")}
            </div>

            {/* 10. Where do you usually wash your hands? */}
            <div>
              <ThinDropdownWithSearch
                label="Where do you usually wash your hands?"
                options={WashHands}
                value={washHand}
                onChange={handleWashChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("washHand")}
            </div>

            {/* 11. How does your household usually dispose of garbage? */}
            <div>
              <ThinDropdownWithSearch
                label="How does your household usually dispose of garbage?"
                options={garbageDispose}
                value={garbage}
                onChange={handleGarbageChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("garbage")}
            </div>

            {/* 12. Is water available at the place for handwashing? */}
            <div>
              <p className="mb-2 text-sm font-medium text-gray-700">
                Is water available at the place for handwashing?
              </p>
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="water-available"
                    value={1}
                    checked={water === 1 || water === true}
                    onChange={() => handleWaterAvailableChange(1)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">Yes</span>
                </label>
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="water-available"
                    value={0}
                    checked={water === 0 || water === false}
                    onChange={() => handleWaterAvailableChange(0)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">No</span>
                </label>
              </div>
              {Err("water")}
            </div>

            {/* 13. Is soap/detergent available... */}
            <div>
              <p className="mb-2 text-sm font-medium text-gray-700">
                Is soap/detergent available at the place for handwashing?
              </p>
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="soap"
                    value={1}
                    checked={soap === 1 || soap === true}
                    onChange={() => handleWashHandChange(1)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">Yes</span>
                </label>
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="soap"
                    value={0}
                    checked={soap === 0 || soap === false}
                    onChange={() => handleWashHandChange(0)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">No</span>
                </label>
              </div>
              {Err("soap")}
            </div>

            {/* 14. Type of Toilets */}
            <div>
              <ThinDropdownWithSearch
                label="Type of Toilets"
                options={Toilet}
                value={toilet}
                onChange={handleToiletChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("toilet")}
            </div>

            {/* 15. Fuel used for Lighting */}
            <div className="flex flex-col">
              <ThinDropdownWithSearch
                label="Fuel used for Lighting"
                options={Fuel}
                value={fuel}
                onChange={handleFuelChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("fuel")}
              {fuel === "Others" && (
                <>
                  <ThinTextField
                    label="Specify other fuel used for lighting"
                    value={fuelOthers}
                    isRequired={true}
                    onChange={(e) => setFuelOthers(e.target.value)}
                    disabled={isDqaApproved || isDqaRejected}
                    className="mt-2"
                  />
                  {Err("fuelOthers")}
                </>
              )}
            </div>

            {/* 19. Cost of fuel for lighting per month */}
            <div>
              <ThinTextField
                value={lightingCostPerMonth}
                label="Cost of fuel for lighting per month"
                isRequired={true}
                onChange={(e) =>
                  setLightingCostPerMonth(e.target.value.slice(0, 5))
                }
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("lightingCostPerMonth")}
            </div>

            {/* 16. Fuel used for Cooking */}
            <div className="flex flex-col">
              <ThinDropdownWithSearch
                label="Fuel used for Cooking"
                options={Cooking}
                value={cooking}
                onChange={handleCookingChange}
                required
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("cooking")}
              {cooking === "Others" && (
                <>
                  <ThinTextField
                    label="Specify other fuel used for cooking"
                    value={cookingOthers}
                    isRequired={true}
                    onChange={(e) => setCookingOthers(e.target.value)}
                    disabled={isDqaApproved || isDqaRejected}
                    className="mt-2"
                  />
                  {Err("cookingOthers")}
                </>
              )}
            </div>

            {/* 20. Cost of fuel used for cooking per month */}
            <div>
              <ThinTextField
                value={cookingCostPerMonth}
                label="Cost of fuel used for cooking per month"
                isRequired={true}
                onChange={(e) =>
                  setCookingCostPerMonth(e.target.value.slice(0, 5))
                }
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("cookingCostPerMonth")}
            </div>

            {/* 17. Do you have a separate kitchen in the house? */}
            <div>
              <p className="mb-2 text-sm font-medium text-gray-700">
                Do you have a separate kitchen in the house?
              </p>
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="separate-kitchen"
                    value={1}
                    checked={separateKitchen === 1 || separateKitchen === true}
                    onChange={() => handleSeparateKitchenChange(1)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">Yes</span>
                </label>
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="separate-kitchen"
                    value={0}
                    checked={separateKitchen === 0 || separateKitchen === false}
                    onChange={() => handleSeparateKitchenChange(0)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">No</span>
                </label>
              </div>
            </div>

            {/* 18. Does your stove have a chimney? */}
            <div>
              <p className="mb-2 text-sm font-medium text-gray-700">
                Does your stove have a chimney?
              </p>
              <div className="flex items-center gap-4">
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="has-chimney"
                    value={1}
                    checked={hasChimney === 1 || hasChimney === true}
                    onChange={() => handleHasChimneyChange(1)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">Yes</span>
                </label>
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="has-chimney"
                    value={0}
                    checked={hasChimney === 0 || hasChimney === false}
                    onChange={() => handleHasChimneyChange(0)}
                    className="accent-blue-600"
                    disabled={isDqaApproved || isDqaRejected}
                  />
                  <span className="text-sm text-gray-700">No</span>
                </label>
              </div>
            </div>

            {/* 21. Height of house in feet */}
            <div>
              <ThinTextField
                value={heightOfHouse}
                label="What is the Plinth height from ground level to finished floor level of the house"
                isRequired={false}
                onChange={(e) => setHeightOfHouse(e.target.value)}
                disabled={isDqaApproved || isDqaRejected}
              />
              {Err("heightOfHouse")}
            </div>
          </div>

          {isDataValid && !isDqaApproved && !isDqaRejected && (
            <div className="mt-8 flex justify-end">
              <button
                type="button"
                onClick={handleUpdateHousing}
                className="bg-teal-600 text-white rounded-lg px-4 py-2 hover:bg-teal-700 transition-colors"
              >
                Update
              </button>
            </div>
          )}
        </form>
      ) : (
        <div className="text-center py-8">
          <p className="text-gray-500 italic text-lg">
            No housing data available for this household
          </p>
        </div>
      )}

      {/* Image Modal */}
      {showImageModal && homeImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999]"
          onClick={closeImageModal}
          style={{ zIndex: 9999 }}
        >
          <div
            className="bg-white rounded-lg p-6 max-w-4xl max-h-[90vh] overflow-auto relative shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4 border-b pb-3">
              <h3 className="text-xl font-semibold text-gray-700 flex items-center gap-2">
                <i className="fa fa-image text-blue-500"></i>
                Home Image Preview
              </h3>
              <button
                onClick={closeImageModal}
                className="text-gray-400 hover:text-gray-600 text-3xl font-bold leading-none hover:bg-gray-100 w-8 h-8 rounded-full flex items-center justify-center"
                title="Close"
              >
                ×
              </button>
            </div>

            <div className="text-center">
              <div className="mb-4">
                <img
                  src={getImageUrl(homeImage)}
                  alt="Home Image"
                  className="max-w-full max-h-[60vh] object-contain rounded-lg border shadow-md mx-auto"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextElementSibling.style.display = "block";
                  }}
                />
                <div
                  className="hidden text-gray-500 p-8 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50"
                  style={{ display: "none" }}
                >
                  <i className="fa fa-exclamation-triangle text-4xl mb-4 text-yellow-500"></i>
                  <p className="text-lg font-medium mb-2">
                    Image could not be loaded
                  </p>
                  <p className="text-sm text-gray-600">
                    File: {getDisplayName(homeImage)}
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    URL: {getImageUrl(homeImage)}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    Please check if the file exists or contact support.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-4 pt-3 border-t flex justify-end">
              <button
                onClick={closeImageModal}
                className="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Housting;
